"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportClient = void 0;
const BaseClient_1 = require("../BaseClient");
class ExportClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    post(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/export/post',
                data: request,
            });
            return response.data;
        });
    }
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/export/get',
                params: {
                    id,
                },
            });
            return response.data;
        });
    }
    list(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/export/list',
                data: request,
            });
            return response.data;
        });
    }
    /**
     * Gets result as binary data
     * NOTE this call puts file data into memory, use this call if you need to get result when authenticated with JWT
     * otherwise use getResultUrl method
     *
     * @param exportId
     */
    getResult(exportId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/export/result',
                params: {
                    exportId,
                },
                responseType: 'arraybuffer',
            });
            return {
                data: response.data,
                contentType: response.headers['content-type'],
            };
        });
    }
    getResultUrl(exportId, downloadFileName) {
        let url = `${this.axiosInstance.defaults.baseURL}/api/v1/export/result?exportId=${exportId}`;
        if (downloadFileName) {
            url += `&downloadFileName=${downloadFileName}`;
        }
        return url;
    }
}
exports.ExportClient = ExportClient;
